import { SearchParams } from 'api/types';
import qs from 'query-string';

const toSearchParams = (search: string) => qs.parse(search) as SearchParams;

export default toSearchParams;
